module.exports = __webpack_public_path__ + "img/5-en.f0a467c1.png";